const getEmojiTier = (idTier) => {
  const emojiDictionary = {
    1: '',
    2: '✅',
    3: '⭐',
    4: '',
    5: '✅',
    6: '⭐',
    7: '💎',
    8: '💎',
  };
  return emojiDictionary[idTier] || '';
};

export default getEmojiTier;
